<div class="flex flex-col items-center h-full">
  <div class="flex items-center my-20">
    <img src="/assets/mmi-logo.jpg" alt="MMI Logo" class="h-64" />
  </div>
  <p class="text-3xl w-3/5 text-center">The link you have been provided is no longer valid.</p>
</div>
